<template>
  <CallPlanningLayout>
    <DataTable :data="data" :perPage="25" noSearch>
      <template #head>
        <tr>
          <Th prop="email" sort>Users</Th>
          <Th prop="regions" sort>Regions</Th>
          <Th prop="territories" sort>Territories</Th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>
            <router-link :to="{ name: 'callPlanningManagerUser', params: { userId: item.email } }">{{ item.email }}</router-link>
          </td>
          <td>{{ item.regions.join(', ') || '-' }}</td>
          <td>{{ item.territories.join(', ') || '-' }}</td>
        </tr>
      </template>
    </DataTable>
    <Loader v-if="isLoading" />
  </CallPlanningLayout>
</template>

<script>
import axios from '../../axios'
import { errorDebug } from '../../libraries/common';
import Loader from '../../components/common/loader/Loader.vue';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Th from '../../components/common/dataTable/Th.vue';
import CallPlanningLayout from '../../components/callPlanning/CallPlanningLayout.vue';
export default {
  components: { Loader, DataTable, Th, CallPlanningLayout, },
  data() {
    return {
      data: null,
      isLoading: false,
    };
  },
  methods: {
    getData() {
      var brandId = this.$route.params.brandId;
      this.isLoading = true;
      axios.get(`/api/CallPlanning/${brandId}/Manager/GetUsers`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningUsersUnderManager'] = this;
    this.getData();
  }
}
</script>